export const PATH_TRACKER = '/:date';
export const PATH_TRACKER_SETTINGS = '/settings';
export const PATH_TRACKER_SETTINGS_MACRO = '/settings/macro';
export const PATH_TRACKER_MEAL = '/:date/meal-details/:dietMealId';
export const PATH_TRACKER_EDIT_MEAL = '/:date/meal-details/:dietMealId/edit-meal';
export const PATH_TRACKER_ADD_INGREDIENT =
  '/:date/meal-details/:dietMealId/edit-meal/add-ingredient';
export const PATH_TRACKER_ADD_INGREDIENT_SCAN_BARCODE =
  '/:date/meal-details/:dietMealId/edit-meal/add-ingredient/scan-barcode';

export const PATH_TRACKER_DESCRIBE_MEAL = '/describe-meal';
export const PATH_TRACKER_DESCRIBE_MEAL_MEAL = '/describe-meal/meal-details/:dietMealId';
export const PATH_TRACKER_DESCRIBE_MEAL_EDIT = '/describe-meal/meal-details/:dietMealId/edit-meal';
export const PATH_TRACKER_DESCRIBE_ADD_INGREDIENT =
  '/describe-meal/meal-details/:dietMealId/edit-meal/add-ingredient';
export const PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_SCAN_BARCODE =
  '/describe-meal/meal-details/:dietMealId/edit-meal/add-ingredient/scan-barcode';

export const PATH_TRACKER_DESCRIBE_MEAL_VOICE = '/describe-meal/by-voice';

export const PATH_TRACKER_SCAN_PLATE = '/scan-plate';
export const PATH_TRACKER_SCAN_PLATE_DETAILS = '/scan-plate/details';

export const PATH_TRACKER_SCAN_BARCODE = '/scan-barcode';
